<template>
  <d2-container>
    <el-form label-width="200px">
      <footer>
        <el-button  icon="el-icon-plus" type="primary" size="small" @click="add">添加任务</el-button>
        <el-button  icon="el-icon-refresh" type="primary" size="small" @click="getTaskList">刷新</el-button>
      </footer>
    </el-form>
    <!-- 任务列表 -->
    <el-table :data="taskList" size="small" >
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="name" label="名称" width="120"></el-table-column>
      <!-- 主题图 -->
      <el-table-column prop="themeThumbnail" label="主题图" width="200">
        <template slot-scope="scope">
          <el-image v-if="scope.row.themeThumbnail" :src="scope.row.themeThumbnail"
           :preview-src-list="[scope.row.themeThumbnail]"
           style="width: 80px; height: 80px;"></el-image>
        </template>
      </el-table-column>
      <!-- 状态 -->
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="info">初始化</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="warning">进行中</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="success">已完成</el-tag>
          <el-tag v-else-if="scope.row.status === 3" type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <!-- 缩略图 -->
      <el-table-column prop="thumbnail" label="输入" width="200">
        <template slot-scope="scope">
          <el-image  :src="scope.row.thumbnail"
           :preview-src-list="[scope.row.thumbnail]"
           style="width: 80px; height: 80px;"></el-image>
        </template>
      </el-table-column>
      <!-- 输出 -->
      <el-table-column prop="outThumbnail" label="输出" width="200">
        <template slot-scope="scope">
          <el-image v-if="scope.row.status === 2 && scope.row.outThumbnail" :src="scope.row.outThumbnail"
           :preview-src-list="[scope.row.outThumbnail]"
           style="width: 80px; height: 80px;"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="info(scope.row.id)" icon="el-icon-view">详情</el-button>
          <el-button v-if="scope.row.status === 2" type="warning" size="mini" @click="download(scope.row.id)" icon="el-icon-download">下载结果</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <!-- 添加任务 -->
    <el-dialog title="添加任务" :visible.sync="dialogVisible" width="60%">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <!-- 单选按钮 -->
          <el-radio-group v-model="form.type" placeholder="请选择类型">
            <el-radio label="0">单图输入</el-radio>
            <el-radio label="1">多图输入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="输入图片" prop="inputUrls">
          <upload-image v-model="form.inputUrls" :max="100" :text="['可批量选取', '图片格式png/jpg', '图片大小100MB以内']"></upload-image>
        </el-form-item>
        <el-form-item label="选择主题">
          <!-- 多选，并且可以按分类选择 -->
          <el-cascader
            v-model="selectedOption"
            :options="themeList"
            :props="{ multiple: true, checkStrictly: true }"
            :show-all-levels="false"
            collapse-tags
            multiple
            clearable
          >
            <template slot-scope="{ data }">
              <span>
                <el-image
                :src="data.cover" style="width: 20px; margin-right: 8px; border-radius: 4px;height: 20px;"
                 :preview-src-list="[data.cover]"
                 />
                {{ data.label }}
              </span>
            </template>
          </el-cascader>
        </el-form-item>
      </el-form>
      <footer>
        <el-button type="primary" @click="addConfirm">添加</el-button>
        <el-button type="primary" @click="cancel">取消</el-button>
      </footer>
    </el-dialog>
  </d2-container>
</template>
<script>
import { getAigcTaskList, getWorkflowThemeCascader, addAigcTask, downloadAigcTaskResult } from '@/api/merchant/service/project'
import UploadImage from '@/components/uploadImage/index.vue'
export default {
  components: {
    UploadImage
  },
  name: 'aigcTask',
  data () {
    return {
      selectedOption: [],
      themeList: [],
      dialogVisible: false,
      form: {
        name: '',
        type: '0', // 0 单图输入 1 多图输入
        inputUrls: []
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      taskList: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        inputUrls: [
          { required: true, message: '请上传输入图片', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.getTaskList()
  },
  methods: {
    info (id) {
      this.$router.push({
        path: '/merchant/service/project/aigcTaskInfo',
        query: {
          id: id
        }
      })
    },
    getTaskList () {
      getAigcTaskList({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        console.log(res)
        this.taskList = res.records
        this.total = parseInt(res.total)
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTaskList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTaskList()
    },
    getThemeList () {
      getWorkflowThemeCascader().then(res => {
        this.themeList = res
      })
    },
    add () {
      this.getThemeList()
      this.dialogVisible = true
    },
    addConfirm () {
      let themeIds = []
      this.selectedOption.forEach(item => {
        if (item.length == 1) {
          // 获取所有子分类
          this.themeList.forEach(theme => {
            if (theme.value == item[0]) {
              theme.children.forEach(child => {
                themeIds.push(child.value)
              })
            }
          })
        } else {
          themeIds.push(item[1])
        }
      })
      console.log(themeIds)
      // 去重
      themeIds = [...new Set(themeIds)]
      console.log(themeIds)
      if (themeIds.length == 0) {
        this.$message.error('请选择主题')
        return
      }
      // loading
      let loading = this.$loading(
        {
          text: '正在加入任务...'
        }
      )
      // 校验表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 添加任务
          addAigcTask({
            name: this.form.name,
            type: this.form.type,
            inputUrls: this.form.inputUrls,
            themeIds: themeIds
          }).then(res => {
            this.$message.success('添加成功')
            this.dialogVisible = false
            this.getTaskList()
            // 关闭loading
            loading.close()
          }).catch(err => {
            this.$message.error('添加失败')
            // 关闭loading
            loading.close()
          })
        }
      })
    },
    cancel () {
      this.dialogVisible = false
    },
    download (id) {
      // loading
      let loading = this.$loading(
        {
          text: '正在下载文件...'
        }
      )
      // 下载压缩文件
      downloadAigcTaskResult(id).then(res => {
        console.log(res)
        // 下载文件
        const blob = new Blob([res], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = 'result.zip'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
        this.$message.success('下载成功')
        // 关闭loading
        loading.close()
      }).catch(err => {
        this.$message.error('下载失败')
        // 关闭loading
        loading.close()
      })
    }
  }
}
</script>
